module.exports = __webpack_public_path__ + "static/img/bus-content.60a39c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bus-content.png
// module id = PqM2
// module chunks = 0